import Banner from '../../../sections/common/banner';
import SectionServices4 from '../../../sections/services/section-services4';
import SectionEstimation1 from '../../../sections/home/index/section-estimation1';
import SectionBooking1 from '../../../sections/home/index/section-booking1';
import { data } from '../../../../globals/data/global-services';
import { Route, Routes } from 'react-router-dom';
import Error404Page from '../../misc/error404';
import PrivateClientStorage from './PrivateClientStorage';
import SecureLogistics from './SecureLogistics';
import LongHaulTransportation from './LongHaulTransportation';
import DistributionSolutions from './DistributionSolutions';
import CustomsClearance from './CustomsClearance';
import SecureVaultsAndBondedWarehouses from './SecureVaultsAndBondedWarehouses';
import { data as estimationData } from '../../../../globals/data/home3';
import ServicesPageHelmet from '../../../helmets/ServicesPageHelmet';
export default function GlobalServices() {
  return (
    <Routes>
      <Route path='/' element={<Services />} />
      <Route
        path='/private-client-storage'
        element={<PrivateClientStorage />}
      />
      <Route path='/secure-logistics' element={<SecureLogistics />} />
      <Route
        path='/long-haul-transportation'
        element={<LongHaulTransportation />}
      />
      <Route
        path='/distribution-solutions'
        element={<DistributionSolutions />}
      />
      <Route path='/customs-clearance' element={<CustomsClearance />} />
      <Route
        path='/secure-vaults-and-bonded-warehouses'
        element={<SecureVaultsAndBondedWarehouses />}
      />
      <Route path='*' element={<Error404Page />} />
    </Routes>
  );
}

const Services = () => {
  return (
    <>
      <ServicesPageHelmet />
      <Banner _data={data.banner} />
      <SectionServices4 _data={data.services} />
      <SectionEstimation1 _data={estimationData.estimation} />
      <SectionBooking1 _data={data.booking} />
      {/* <SectionClients1 key={1} _data={data.clients} /> */}
    </>
  );
};
